import { render } from "./FooterComponent.vue?vue&type=template&id=c4aaa904&scoped=true"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "@/assets/css/footer_other.css?vue&type=style&index=0&id=c4aaa904&scoped=true&lang=css&external"
import "./FooterComponent.vue?vue&type=style&index=1&id=c4aaa904&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4aaa904"]])

export default __exports__